/** A price discount; null provider or model means "any". */
export interface DiscountData {
	id: string;
	provider: string | null;
	model: string | null;
	/** Stored as a fraction: "0.25" is 25% off. */
	discountPercent: string;
	reason: string | null;
	expiresAt: string | null;
	createdAt: string;
}

/** Only fractions in (0, 1] count; anything else would break prices. */
export function isValidDiscount(discount?: string | null): boolean {
	if (!discount) {
		return false;
	}
	const value = Number(discount);
	return Number.isFinite(value) && value > 0 && value <= 1;
}

/** The share taken off the price, or 0 with no valid discount. */
export function discountFraction(discount?: string | null): number {
	return isValidDiscount(discount) ? Number(discount) : 0;
}

/** A per-token price (as the API sends it) scaled to per million tokens. */
export function perMillion(
	price: string | number | null | undefined,
): number | null {
	if (price === null || price === undefined || price === "") {
		return null;
	}
	const value = Number(price);
	return Number.isFinite(value) ? value * 1e6 : null;
}
